/**
 * Created by: cparaschiv
 * Date: 04.04.2013, 17:50
 */

TS.ns('TS.cultures');

(function(window, undefined) {
    TS.cultures['ro-RO'] = {
        name: 'ro-RO',
        language: "ro",
        decimalseparator: ',',
        thousandsseparator: ' ',
        numberFormat: {
            ',': " ",
            '.': ",",
            percent: {
                ',': " ",
                '.': ","
            },
            currency: {
                pattern: ["-n $", "n $"],
                ',': " ",
                '.': ",",
                symbol: "€"
            }
        },
        common: {
            Add: 'Adaugă',
            Edit: 'Modifică',
            Delete: 'Şterge',
            Save: 'Salvează',
            Close: 'Închide',
            Cancel: 'Anulează',
            Confirm: 'Confirmare',
            Yes: 'Da',
            No: 'Nu',
            EmptySelection: '<nespecificat>'
        },

        sessionExpired: {
            Title: 'Sesiunea de lucru a expirat',
            Message: 'Veți fi direcționat(ă) către pagina de start.'
        },

        error: {
            LoadError: 'Eroare la încărcarea datelor'
        },

        edit: {
            InvalidDocument: 'Documentul nu este valid. Corectați erorile și încercați din nou.'
        },

        list: {
            NoRecordSelected: 'Selectați cel puțin o înregistrare',
            DeleteSelectedRecords: 'Sunteți sigur(ă) că vreți să ștergeți înregistrările selectate?'
        },

        gridLocalization: {
            // separator of parts of a date (e.g. '/' in 11/05/1955)
            '/': ".",
            // separator of parts of a time (e.g. ':' in 05:44 PM)
            ':': ":",
            // the first day of the week (0 = Sunday, 1 = Monday, etc)
            firstDay: 1,
            days: {
                names: ["duminică","luni","marţi","miercuri","joi","vineri","sâmbătă"],
                namesAbbr: ["D","L","Ma","Mi","J","V","S"],
                namesShort: ["D","L","Ma","Mi","J","V","S"]
            },
            months: {
                names: ["ianuarie","februarie","martie","aprilie","mai","iunie","iulie","august","septembrie","octombrie","noiembrie","decembrie",""],
                namesAbbr: ["ian.","feb.","mar.","apr.","mai.","iun.","iul.","aug.","sep.","oct.","nov.","dec.",""]
            },
            // AM and PM designators in one of these forms:
            // The usual view, and the upper and lower case versions
            //      [standard,lowercase,uppercase]
            // The culture does not use AM or PM (likely all standard date formats use 24 hour time)
            //      null
            AM: ["AM", "am", "AM"],
            PM: ["PM", "pm", "PM"],
            eras: [
            // eras in reverse chronological order.
            // name: the name of the era in this culture (e.g. A.D., C.E.)
            // start: when the era starts in ticks (gregorian, gmt), null if it is the earliest supported era.
            // offset: offset in years from gregorian calendar
            {"name": "A.D.", "start": null, "offset": 0 }
            ],
            twoDigitYearMax: 2029,
            patterns: {
                // short date pattern
                d: "dd.MM.yyyy",
                // long date pattern
                D: "dddd, dd MMMM, yyyy",
                // short time pattern
                t: "h:mm tt",
                // long time pattern
                T: "h:mm:ss tt",
                // long date, short time pattern
                f: "dddd, dd MMMM, yyyy h:mm tt",
                // long date, long time pattern
                F: "dddd, dd MMMM, yyyy h:mm:ss tt",
                // month/day pattern
                M: "dd MMMM",
                // month/year pattern
                Y: "MMMM yyyy",
                // S is a sortable format that does not vary by culture
                S: "yyyy\u0027-\u0027MM\u0027-\u0027dd\u0027T\u0027HH\u0027:\u0027mm\u0027:\u0027ss",
                // formatting of dates in MySQL DataBases
                ISO: "yyyy-MM-dd hh:mm:ss",
                ISO2: "yyyy-MM-dd HH:mm:ss",
                d1: "dd.MM.yyyy",
                d2: "dd-MM-yyyy",
                d3: "dd-MMMM-yyyy",
                d4: "dd-MM-yy",
                d5: "H:mm",
                d6: "HH:mm",
                d7: "HH:mm tt",
                d8: "dd/MMMM/yyyy",
                d9: "MMMM-dd",
                d10: "dd-MM",
                d11: "dd-MM-yyyy"
            },
            percentsymbol: "%",
            currencysymbol: "RON",
            currencysymbolposition: "înainte",
            decimalseparator: ',',
            thousandsseparator: ' ',
            pagergotopagestring: "Salt la pagina:",
            pagershowrowsstring: "Nr. rânduri:",
            pagerrangestring: " din ",
            pagerpreviousbuttonstring: "Pagina anterioară",
            pagernextbuttonstring: "Pagina următoare",
            groupsheaderstring: "Trageți de o coloană și dați-i drumul aici pentru a grupa",
            sortascendingstring: "Ordonează ascendent",
            sortdescendingstring: "Ordonează descendent",
            sortremovestring: "Elimină ordonarea",
            groupbystring: "Grupează după coloana aceasta",
            groupremovestring: "Elimină din grupuri",
            filterclearstring: "Curăță",
            filterstring: "Filtrează",
            filtershowrowstring: "Arată rândurile care:",
            filterorconditionstring: "Sau",
            filterandconditionstring: "Şi",
            filterselectallstring: "(Selectați tot)",
            filterchoosestring: "Alegeți:",
            filterstringcomparisonoperators: ['nespecificat', 'specificat', 'conține', 'conține(potrivire după litere)',
               'nu conține', 'nu conține(potrivire după litere)', 'începe cu', 'începe cu(potrivire după litere)',
               'se termină cu', 'se termină cu(potrivire după litere)', 'egal', 'egal(potrivire după litere)', 'null', 'nu este null'],
            filternumericcomparisonoperators: ['egal', 'inegal', 'mai mic decât', 'mai mic sau egal cu', 'mai mare decât', 'mai mare sau egal cu', 'null', 'nu este null'],
            filterdatecomparisonoperators: ['egal', 'inegal', 'mai mic decât', 'mai mic sau egal cu', 'mai mare decât', 'mai mare sau egal cu', 'null', 'nu este null'],
            filterbooleancomparisonoperators: ['egal', 'inegal'],
            validationstring: "Valoarea introdusă nu este validă",
            emptydatastring: "Nimic de afișat",
            filterselectstring: "Selectează filtru",
            loadtext: "Se încarcă...",
            clearstring: "Șterge",
            todaystring: "Astăzi",
            emptyContent: 'Nimic de afișat'
        },

        treeLocalization: {
            AddRoot: 'Adaugă rădăcină',
            ExpandAll: 'Extinde tot',
            CollapseAll: 'Restrânge tot'
        },

        pagerMessages: {
            display: "Înregistrările {0} - {1} din {2}",
            empty: "Nimic de afișat",
            page: "Pagina",
            of: "din {0}",
            itemsPerPage: "înregistrări pe pagină",
            first: "Prima pagină",
            previous: "Pagina anterioară",
            next: "Pagina următoare",
            last: "Ultima pagină",
            refresh: "Împrospătare",
            morePages: "Mai multe pagini"
        },

        validation: {
            RequiredValue: 'Introduceți valoarea',
            InvalidValue: 'Valoarea introdusă nu este validă'
        },

        messageBox: {
        	buttons: {
        		OK: 'OK',
        		Cancel: 'Anuleaza',
        		Abort: 'Renunta',
        		Retry: 'Reincearca',
        		Ignore: 'Ignora',
        		Yes: 'Da',
        		No: 'Nu'
        	}
        },
        fileUploadMessages: {
            Loading: 'Se încarcă',
            Error: 'Eroare',
            SelectFile: 'Încarcă',
            InitialDescription: 'Apăsați butonul Încarcă',
            DragOverHint: 'Dați drumul fișierului pentru a începe încărcarea',
            UploadCancelled: 'Încărcare oprită'
        }
    }
})(this);
